{
	"audiences": {
		"admin": "General admin",
		"manager": "Facility manager",
		"student": "Student"
	},
	"blocks": {
		"body": "Text",
		"button": "Button",
		"greeting": "Greeting",
		"heading": "Heading",
		"link_body": "Text of the link",
		"note": "Closing note",
		"preview": "Inbox preview",
		"subject": "Subject"
	},
	"columns": {
		"audience": "Recipient",
		"code": "Code",
		"email": "Email",
		"en": "English",
		"it": "Italian"
	},
	"content_title": "Email content",
	"default_text": "Default text",
	"emails": {
		"A1": "Sending anomaly",
		"A2": "Forfeiture not confirmed",
		"A3": "DSU quota below threshold",
		"E1": "Sign-in code",
		"E11": "Place acceptance confirmation",
		"E12": "Renunciation confirmation",
		"E13": "Forfeiture confirmed",
		"E15": "Exclusion or revocation",
		"E15C": "Exclusion cancelled",
		"E16": "Room proposal",
		"E19": "Application valid",
		"E20": "Problem in the application",
		"E21": "Disability priority not confirmed",
		"E22": "Student number request",
		"E3": "Application receipt",
		"E4": "Application withdrawal confirmation",
		"E5": "Direct application registered by the manager",
		"E6": "Request for clarification",
		"E7": "Outcome of the application check",
		"E8": "Ranking published",
		"G1": "Account invitation",
		"G10": "New residence assigned",
		"G3": "Application not delivered to the call PEC",
		"G4": "Reminder",
		"G5": "New report on the ranking",
		"G6": "Control ranking ready",
		"G7": "Offer not delivered",
		"G8": "Offers to send from the residence PEC",
		"G9": "DSU place not covered"
	},
	"error": "The texts could not be loaded. Reload the page.",
	"history": "Versions",
	"history_default": "Version 1, default text",
	"history_item": "Version {{version}}, {{date}}, {{name}}",
	"issues": {
		"empty": "Write the text of this block.",
		"malformed_variable": "A brace is not part of a variable: write a variable with one brace on each side, like {nome}.",
		"missing_variable": "{{variable}} is missing: put it back in the text.",
		"repeated_variable": "{{variable}} can be used only once in this block.",
		"unknown_block": "This block does not exist in this email.",
		"unknown_variable": "{{variable}} cannot be used here."
	},
	"legal": {
		"description": "The offer (E9) and the PECs (P1-P4) belong to the call rules: they are not edited here and are read in the call notice PDF of each residence.",
		"title": "Texts with legal value"
	},
	"locales": {
		"en": "English",
		"it": "Italian"
	},
	"not_found": "This email has no editable text.",
	"page_title": "Email texts",
	"preview_title": "Preview",
	"required": "Required: {{variables}}.",
	"save": "Save a new version",
	"saved": "New version saved: the next emails will use this text.",
	"subject": "Subject:",
	"variables": "Variables:",
	"variables_global": "You can use {piattaforma} in any text: it is replaced with the name of the platform.",
	"version_on": "Version {{version}} of {{date}}"
}
